import { commonEnvVariables } from "@/commonEnvVariables";

const envVariables = commonEnvVariables();

export const privacySettingsConstants = {
    MY_VISIBILITY: 'My Visibility',
    PRIVACY_SETTINGS: 'Emails & Notifications',
    NOTIFICATIONS: 'Notifications',
    EMAILS: 'Emails',
    FORUM: 'Forum',
    CHAPTER: 'Chapter',
    REGION: 'Region',
    NETWORK: 'Network',
    GROUP: 'Group',
    MY_FORUMS: 'MY FORUMS',
    MY_CHAPTERS: 'MY CHAPTERS',
    MY_NETWORKS: 'MY NETWORKS',
    MY_REGIONS: 'MY REGIONS',
    MY_GROUPS: 'MY GROUPS',
};
export const notificationConstants = {
    NOTIFICATIONS: 'Notifications',
    DESC: 'Manage the notifications you receive on YPO and via your mobile device.',
    MEMBER_ACTIVITY: 'Member Activity',
    EVENTS: 'Events',
    YPO_ANNOUNCEMENTS: 'YPO Announcements',
    ON_CONNECT: 'On Connect',
    MOBILE_ALERTS: 'Mobile Alerts',
    NOTIFY_ME_FOR: 'Notify Me For',
    DONT_NOTIFY_ME: "Don't Notify me",
    ALL_MEMBERS: 'All Members',
    NEW_ACTIVITY: 'New Activity',
    HOME_NEWSFEED: 'Home Newsfeed',
    ALL_COMMUNITY_CONVERSATIONS: 'All Community Conversations',
    SAVE_CONFIRMATION: 'You successfully changed your notification settings.',
    SAVE_ERROR:
        'Due to technical issues, we are currently unable to change your notification settings. Please try again later.',
};

export const emailConstants = {
    EMAILS: "Emails",
    YPO_DEFAULT_CHAPTER: 'YPO Default Chapter',
    YPO_DEFAULT_FORUM: 'YPO Default Forum',
    YPO_DEFAULT_REGION: 'YPO Default Region',
    YPO_DEFAULT_NETWORK: 'YPO Default Network',
    YPO_DEFAULT_GROUP: 'YPO Default Group',
    SAVE_CONFIRMATION: 'You successfully changed your email settings.',
    SAVE_ERROR:
        'Due to technical issues, we are currently unable to change your email settings. Please try again later.',
    Champion_Development_and_Recognition: 'Champion Development and Recognition',
    YPO_Champion: 'Required communications for YPO Champions',
    COMMUNITY_ACTIVITY: 'My Community Activity',
    SEND_UPDATES: 'Send me updates',
    YPO_ACCOUNT: 'YPO Account & Administration',
    YPO_BOARD: 'YPO Board of Directors Dashboard',
    PHISHING_NOTIFICATIONS: 'Phishing Notifications',
    SELECT_ALL: 'Select All',
    EMAIL_UPDATES: [
        { text: 'Instantly', value: 0 },
        { text: 'Daily', value: 1 },
        { text: 'Weekly', value: 2 },
        { text: 'Never', value: 3 },
    ],
};

export const myVisibilityConstants = {
    MYVISIBILITY: 'My Visibility',
    MY_ONLINES_STATUS: 'My Online Status',
    INDICATE_WHEN_I_AM_ONLINE: 'Indicate when I’m online:',
    SHOW_NO_ONE_CONFIRMATION:
        'You successfully changed your visibility settings. Users cannot see your location or online status.',
    OTHER_CONFIRMATION: 'You successfully changed your visibility settings. Your location is currently visible.',
    SAVE_WARNING:
        'Due to technical issues, we are currently unable to change your visibility settings. Please try again later.',
};

export const YPOAccountConstants = {
    options: [
        {
            title: 'Membership Renewals',
            key: 'MembershipRenewals',
        },
        {
            title: 'YPO Policies and Procedures updates/revisions',
            key: 'YPOPolicies',
        },
        {
            title: 'Membership dues',
            key: 'MembershipDues',
        },
        {
            title: 'Membership safety',
            key: 'Membershipsaftey',
        },
        {
            title: 'Organization strategic evolution',
            key: 'OrganizationStrategicEvolution',
        },
        {
            title: 'Organization crisis/crisis response',
            key: 'OrganizationCrisis',
        },
        {
            title: 'Account changes',
            key: 'AccountChanges',
        },
    ],
};

export const championOptions = {
    defaultOptions: [
        {
            title: 'Key updates from the YPO Chairman or YPO CEO',
            key: 'KeyUpdates',
        },
        {
            title: 'Officer education news and information',
            key: 'OfficerEducation',
        },
        {
            title: 'Officer nominations, elections and announcements',
            key: 'OfficerNominations',
        },
        {
            title: 'Champion awards, nominations and announcements',
            key: 'ChampionAwards',
        },
        {
            title: 'Global Leadership Conference (GLC)',
            key: 'GlobalLeadership',
        },
        {
            title: 'Chapter Leadership Workshops (CLW)',
            key: 'ChapterLeadership',
        },
    ],
};

export const policiesAndTerms = {
    privacyPolicy: [
        {
            name: 'Community Standards',
            name2: '',
            url: "https://www2.ypoconnect.org/topics/24644/page/community-standards",
            url2: '',
        },
        {
            name: 'Conflict of Interest Policy',
            name2: '',
            url: 'https://www2.ypoconnect.org/topics/24644/media_center/folder/5cada228-197f-4f25-b7e1-ae2f18bb70b1',
            url2: '',
        },
        {
            name: 'Groups Terms & Conditions',
            name2: '',
            url: `${envVariables.BLOB_CDN_END_POINT}/publiclyaccessiblefiles/Group_Terms_And_Conditions.pdf`,
            url2: '',
        },
        {
            name: 'Networks Terms & Conditions',
            name2: '',
            url: 'https://connect.ypowpo.org/Portal/department/networks-and-groups/training-and-tools/network-terms-and-conditions',
            url2: '',
        },
        {
            name: 'Policies & Procedures',
            name2: '',
            url: 'https://www2.ypoconnect.org/topics/24644/media_center/folder/f3ef569f-e46c-45be-b900-30eb78b9f781',
            url2: '',
        },
        {
            name: 'Political Advocacy Guidelines',
            name2: '',
            url: `${envVariables.BLOB_CDN_END_POINT}/publiclyaccessiblefiles/6f5aafd4-7ff9-44b1-866c-0255d439934b.pdf`,
            url2: '',
        },
        {
            name: 'Privacy Notice & Terms of Use',
            name2: '',
            url:`https://www2.ypoconnect.org/topics/24644/media_center/folder/84f9e590-6a67-420f-9435-b978df17a065`,
            url2: '',
        },
        {
            name: 'YPO Brand and Social Media Policy',
            name2: '',
            url:`https://www2.ypoconnect.org/topics/24644/media_center/folder/b5edd8ab-91cd-4a4e-be74-d6f877cd3baa`,
            url2: '',
        },
        {
            name: 'YPO Financials & Board Minutes',
            name2: '',
            url:`https://www2.ypoconnect.org/topics/24644/media_center`,
            url2: '',
        },
        {
            name: 'Report an Issue',
            name2: '',
            url: 'https://secure.ethicspoint.com/domain/media/en/gui/12443/index.html1',
            url2: '',
        },
    ],
};

export const forumOptions = {
    forumModerator: [
        {
            title: 'Forum Moderator Update',
            key: 'ForumModerator',
        },
    ],
    ForumWiseNewsletter: [
        {
            title: 'ForumWise newsletter',
            key: 'ForumNewsletter',
        },
    ],
};
